if (!customElements.get("swiper-product-group")) {
    class SwiperProductGroup extends HTMLElement {
        constructor() {
            super();
            this.initProductSwiper();
            this.initMainSwiper();
            this.initSwatchEvent();
            this.observeSwiper();
            this.moreButton();
        }
        moreButton() {
            const productGroupSwiperButtons = this.querySelectorAll('.k-custom__more_button');
            productGroupSwiperButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    const target = button.previousElementSibling;
                    // 检查 target 是否存在且是否具有 .more-button-target 类
                    if (target && target.classList.contains('more-button-target')) {
                        // 只改变 .more-button-target 的直接子元素
                        Array.from(target.children).forEach((child) => {
                            child.style.display = 'block';
                        });
                        button.style.display = 'none';
                    }
                });
            });
        }

        initProductSwiper() {
            const swiperContainer = this.querySelector(".swiper-product-group-product-swiper");

            if (swiperContainer) {
                this.productSwiperInstance = new Swiper(swiperContainer, {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    effect: 'fade',
                    observer: true,
                    autoHeight: true,
                    fadeEffect: {
                        crossFade: true,
                    },
                    allowTouchMove: false,
                });
            }
        }

        initMainSwiper() {
            const swiperContainer = this.querySelector(".swiper-product-group-image-swiper");

            if (swiperContainer && this.productSwiperInstance) {
                const vwUnit = window.innerWidth / 100; // 1vw 的值
                const offsetValue = (40 / 750) * 100 * vwUnit;
                this.swiperInstance = new Swiper(swiperContainer, {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    autoHeight: true,
                    pagination: {
                        el: swiperContainer.querySelector(".swiper-pagination"),
                        clickable: true,
                    },
                    navigation: {
                        nextEl: swiperContainer.querySelector(".swiper-button-next"),
                        prevEl: swiperContainer.querySelector(".swiper-button-prev"),
                    },
                    scrollbar: {
                        el: swiperContainer.querySelector('.swiper-scrollbar'),
                        draggable: true,
                    },
                    thumbs: {
                        swiper: this.productSwiperInstance,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1.29,
                            spaceBetween: offsetValue,
                            slidesOffsetAfter: offsetValue,
                            slidesOffsetBefore: offsetValue,
                            loop: false,
                        },
                        768: {
                            slidesPerView: 1.19,
                            spaceBetween: offsetValue,
                            slidesOffsetAfter: offsetValue,
                            slidesOffsetBefore: offsetValue,
                            loop: false,
                        },
                        1001: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                            loop: true,
                        }
                    }
                });
            }
        }

        initSwatchEvent() {
            this.addEventListener('mouseenter', (event) => {
                const target = event.target;
                if (target.matches('.swatch__list_js > span')) {
                    const nowid = target.getAttribute('data-vid');
                    console.log('nowid:', nowid);

                    const comproitem = target.closest('.comproitem');
                    if (comproitem) {
                        const combieInput = comproitem.querySelector('.js_sticky_combie');
                        if (combieInput) {
                            combieInput.value = nowid;
                        }
                    }
                }
            }, true); // 使用捕获阶段监听
        }

        observeSwiper() {
            const swiperContainer = this.querySelector(".swiper-product-group-product-swiper");

            if (swiperContainer) {
                const resizeObserver = new ResizeObserver(() => {
                    if (this.productSwiperInstance) {
                        this.productSwiperInstance.update(); // 当高度变化时更新Swiper实例的大小
                    }
                });

                // 观察每一个 swiper-slide 元素的大小变化
                const swiperSlides = swiperContainer.querySelectorAll(".swiper-slide");
                swiperSlides.forEach(slide => {
                    resizeObserver.observe(slide);
                });
            }
        }
    }

    customElements.define("swiper-product-group", SwiperProductGroup);
}
